import { css } from 'emotion';

const iconWrapper = css`
  display: inline;
  float: right;
`;

export default {
  iconWrapper,
};
